import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

import './tag.scss';

export default class Tag extends React.Component {
  static propTypes = {
    capitalize: PropTypes.bool,
    children: PropTypes.any.isRequired,
    label: PropTypes.string,
    name: PropTypes.any,
    newDesignSystem: PropTypes.bool,
    removable: PropTypes.bool,
    onRemove: PropTypes.func
  };

  static defaultProps = {
    removable: false,
    capitalize: true
  };

  manageRemove = (e) => {
    if (this.props.onRemove != null) {
      this.props.onRemove(e, this.props.name);
    }
  };

  render() {
    const { capitalize, newDesignSystem } = this.props;
    const filterTagClasses = `clear-filter-tag
      ${newDesignSystem ? 'ds-filter-tag p-1 d-inline-block' : ''} ${capitalize ? 'text-capitalize' : ''}`;

    return (
      <div className={filterTagClasses}>
        <div className="clear-filter-box">
          {this.props.label && `${this.props.label}: `}
          {this.props.children}
          {this.renderCloseLink()}
        </div>
      </div>
    );
  }

  renderCloseLink() {
    if (!this.props.removable) {
      return null;
    }

    const icon = this.props.newDesignSystem ? faTimesCircle : faTimes;
    const size = this.props.newDesignSystem ? '1x' : 'sm';

    return (
      <React.Fragment>
        &nbsp;
        <FontAwesomeIcon
          className="left-buffer-sm clickable"
          icon={icon}
          name="remove-control"
          size={size}
          onClick={this.manageRemove}
        />
      </React.Fragment>
    );
  }
}
